import { Typography } from '@mui/material';
import  ERR_IMG  from 'app/assets/error.png';
import React from 'react';
 

const NotFound = () => {
  return (
    <div className={'bg-white'}  >
        
      <div className="err" >
        <img width='500px' height='500px' src={ERR_IMG}></img>
      </div>
    </div>
  );
};

export default NotFound;